'use strict';

var _PropTypes$shape;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var InputGroup = require('./InputGroup'),
    Input = require('./Input'),
    Mixin = require('../mixin');

var NAMEPREFIX = 'namePrefix';
var GIVENNAME = 'givenName';
var MIDDLENAME = 'middleName';
var SURNAME = 'surname';
var NAMESUFFIX = 'nameSuffix';
var ALTNAME = 'altName';
var DEFAULT_LAYOUT = [GIVENNAME, MIDDLENAME, SURNAME];

var Name = (function (_React$Component) {
    _inherits(Name, _React$Component);

    function Name(props) {
        _classCallCheck(this, Name);

        _get(Object.getPrototypeOf(Name.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Name';
    }

    _createClass(Name, [{
        key: 'buildNameComponent',
        value: function buildNameComponent(layout) {
            var self = this,
                nameComponent = [],
                name = self.props.name,
                label;

            layout.forEach(function (component) {
                label = self.getLabel(component);
                nameComponent.push(_react2['default'].createElement(Input, {
                    type: 'text',
                    key: component,
                    id: '' + self.props.id_component,
                    label: label,
                    placeholder: label,
                    value: name[component],
                    disabled: self.props.disabled,
                    errors: self.getErrors(component),
                    onChange: self.onFieldChange.bind(self, component),
                    onBlur: self.onFieldBlur.bind(self, component),
                    readOnly: self.props.readOnly }));
            });
            return nameComponent;
        }
    }, {
        key: 'onFieldChange',
        value: function onFieldChange(field, value) {
            var name = this.cloneObject(this.props.name);
            name[field] = value;

            // Call host onChange function.
            this.props.onChange(name);
        }
    }, {
        key: 'onFieldBlur',
        value: function onFieldBlur(field, value) {
            var name = this.cloneObject(this.props.name);
            if (this.props.onBlur) {
                this.props.onBlur(name);
            }
        }
    }, {
        key: 'getLabel',
        value: function getLabel(component) {
            var _props = this.props;
            var layout = _props.layout;
            var dictionary = _props.dictionary;

            var key = 'properties.' + component + '.label';
            var label = this.i18n(layout, key);
            if (!label || label === key) {
                label = this.i18n(dictionary, component + '.label');
            }
            return label;
        }
    }, {
        key: 'render',
        value: function render() {
            var layout = this.props.layout && this.props.layout.layout || DEFAULT_LAYOUT;

            return _react2['default'].createElement(
                InputGroup,
                {
                    id: this.props.id,
                    label: this.props.label,
                    error: this.hasErrors()
                },
                this.buildNameComponent(layout)
            );
        }
    }]);

    return Name;
})(_react2['default'].Component);

Name.propTypes = {
    layout: _propTypes2['default'].object.isRequired,
    name: _propTypes2['default'].shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, NAMEPREFIX, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, GIVENNAME, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, MIDDLENAME, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, SURNAME, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, NAMESUFFIX, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, ALTNAME, _propTypes2['default'].string), _PropTypes$shape)).isRequired,
    dictionary: _propTypes2['default'].object.isRequired,
    onChange: _propTypes2['default'].func.isRequired,
    onBlur: _propTypes2['default'].func,
    label: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    errors: _propTypes2['default'].object,
    contiguous: _propTypes2['default'].bool,
    id: _propTypes2['default'].string,
    readOnly: _propTypes2['default'].bool
};

Name.defaultProps = {
    contiguous: false,
    name: {},
    readOnly: false
};

(0, _reactMixin2['default'])(Name.prototype, Mixin);

module.exports = Name;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Name.js
// module id = 971
// module chunks = 0 1